import { useMutation } from '@tanstack/react-query'

import { api } from '~lib/api'

export const usePublicSgidLogout = () => {
  return useMutation(() => api.url('/sgid/logout').post().text())
}
